import React, { useState, useEffect } from "react";
import { CalciteLoader } from "@esri/calcite-components-react";
import geoJobeLogo from "./images/GEO_Jobe_Logo.png";
import "./styles/GeoJobeLoader.css";

const GeoJobeLoader: React.FC = () => {
    const [calciteReady, setCalciteReady] = useState(false);

    useEffect(() => {
        if (customElements.get('calcite-loader')) {
            setCalciteReady(true);
        } else {
            customElements.whenDefined('calcite-loader').then(() => {
                setCalciteReady(true);
            });
        }
    }, []);

    return (
        <div className="geojobe-loader-overlay">
            <div className="geojobe-loader-content">
                <img
                    src={geoJobeLogo}
                    alt="GEO Jobe"
                    className="geojobe-logo-img"
                />
                {calciteReady ? (
                    <CalciteLoader label="Loading application" scale="l" />
                ) : (
                    <div className="geojobe-spinner" role="status" aria-label="Loading">
                        <div className="spinner-ring"></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GeoJobeLoader;/*  */